import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import TableCellTypography from 'shared/components/widgets/tabel-cell-typography';
import { bytesToSize } from 'shared/helpers/bytes-to-size';
import { getDepartment } from 'shared/helpers/external-delivery/get-department';

export const operationHistoryExternalDeliveryFilesListColumns: GridColDef[] = [
  {
    field: 'histSeq',
    headerName: 'No', // Number
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 80,
    minWidth: 80,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <TableCellTypography>
        {params?.row?.id || params?.row?.id === 0 ? params?.row?.id : '--'}{' '}
      </TableCellTypography>
    ),
  },
  {
    field: 'histDt',
    headerName: '다운로드 일자', // Download Date
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 200,
    minWidth: 200,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <TableCellTypography>{params.value}</TableCellTypography>
    ),
  },
  {
    field: 'remoteIp',
    headerName: '접속IP', // Connection IP
    headerAlign: 'left',
    align: 'left',
    flex: 2,
    maxWidth: 200,
    minWidth: 200,
    renderCell: (params: GridRenderCellParams) => (
      <TableCellTypography>{params.value}</TableCellTypography>
    ),
  },
  {
    field: 'shmLfsKind',
    headerName: '분류', // Classification
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 128,
    minWidth: 128,
    renderCell: (params: GridRenderCellParams) => {
      let classificationValue = params.value ?? '--';
      let classificationLabel = '--';

      switch (classificationValue) {
        case 'proposal':
          classificationLabel = '제안서';
          break;
        case 'brochure':
          classificationLabel = '브로셔';
          break;
        case 'patch_file':
          classificationLabel = '패치파일';
          break;
        case 'install_file':
          classificationLabel = '설치파일';
          break;
        case 'guide':
          classificationLabel = '가이드문서';
          break;
        default:
          classificationLabel = '--';
          break;
      }
      return (
        <TableCellTypography>{classificationLabel ?? '--'}</TableCellTypography>
      );
    },
  },
  {
    field: 'shmDeptCd',
    headerName: '부서', // Department
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 280,
    minWidth: 280,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <TableCellTypography>
          {getDepartment(params.value) ?? '--'}
        </TableCellTypography>
      );
    },
  },
  {
    field: 'shmSubject',
    headerName: '업로드 제목', // Upload Title
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 280,
    minWidth: 280,
    renderCell: (params: GridRenderCellParams) => (
      <TableCellTypography>{params.value}</TableCellTypography>
    ),
  },
  {
    field: 'fileTotalCnt',
    headerName: '다운로드한 총 파일 수', // File Name
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 240,
    minWidth: 240,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <TableCellTypography>{params.value}</TableCellTypography>
    ),
  },
  {
    field: 'fileTotalSize',
    headerName: '파일크기', // File Size
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    sortable: true,
    maxWidth: 132,
    minWidth: 132,
    renderCell: (params: GridRenderCellParams) => (
      <TableCellTypography>{bytesToSize(params.value)}</TableCellTypography>
    ),
  },
];
